import { Button, Flex } from "antd";
import type { ReactNode } from "react";
import { useNavigate } from "react-router";
import EditIcon from "../../../../assets/icons/EditIcon";
import { cn } from "../../../../utils/global.utils";
import type { TProfileEditLink } from "../../profileUpdate/constants";

type Props = {
  title: string;
  onPress?: () => void;
  children?: ReactNode;
  className?: string;
  type?: TProfileEditLink;
};

export default function Section({
  children,
  title,
  onPress,
  className,
  type,
}: Props) {
  const navigate = useNavigate();

  return (
    <section>
      <Flex align="center" justify="space-between" className="mb-2.5">
        <h3 className="text-Base text-lg font-medium text-theme-primary">
          {title}
        </h3>
        <Button
          type="text"
          className="!text-theme-yellow-600"
          onClick={() => (type ? navigate(`update?type=${type}`) : onPress?.())}
          size="small"
          icon={<EditIcon />}
          classNames={{ icon: "relative top-[3px]" }}
        />
      </Flex>

      <div
        className={cn("grid lg:grid-cols-4 md:grid-cols-2 gap-2.5", className)}
      >
        {children}
      </div>
    </section>
  );
}
